import { EighthDoorContent } from 'shared/components/EighthDoorContent';
import { EIGHTH_DOOR_GIFT } from 'shared/constants/links';
import { useDoorContent } from 'shared/hooks';
import { EAdventDoorsHashs, TDoor } from 'shared/types/doors';

export const EighthDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const { handleClickBtn } = useDoorContent({
    doorCode: EAdventDoorsHashs.EighthDoor,
    giftLink: EIGHTH_DOOR_GIFT,
  });

  return <EighthDoorContent onClickBtn={handleClickBtn} {...props} />;
};
